import { createFileRoute } from "@tanstack/react-router";
import { ApplicationsOperationsScreen } from "@modules/applications/views";
import { requireAnySurface } from "./-guards";

/**
 * /staff/rounds/$roundId/applications — "Voir les dossiers" from a round card.
 *
 * `rounds_` (trailing underscore on the ROUNDS segment, not `admin_`) is deliberate: this screen
 * wants the `/staff` layout's AppShell, but NOT `staff/rounds.tsx`'s own component — `RoundsScreen`
 * renders no `<Outlet/>`, so without this escape the router matches this route (URL, breadcrumb)
 * while never actually mounting it, silently leaving the round list on screen. Caught live: the
 * breadcrumb updated to "Dossiers" but the page kept showing the round grid until the escape was
 * added. Same mechanism as `staff_.rounds.$roundId.setup.tsx`'s escape, one layer shallower.
 *
 * Gated on EITHER staff surface (2026-09-13) — this is the coordinator's own screen as much as the
 * administrator's; the backend already treats them as permission-equal here (confirmed against
 * `_require_round`/`CAPABILITIES` in `operations/services.py`).
 */
export const Route = createFileRoute("/staff/rounds_/$roundId/applications")({
  beforeLoad: ({ context, location }) =>
    requireAnySurface(
      context.queryClient,
      ["round_configuration", "intake_operations"],
      location.pathname
    ),
  staticData: {
    breadcrumb: [
      "nav.rounds",
      "breadcrumb.all-rounds",
      "breadcrumb.applications",
    ],
  },
  component: RoundApplicationsRoute,
});

function RoundApplicationsRoute() {
  const { roundId } = Route.useParams();
  return <ApplicationsOperationsScreen roundId={roundId} />;
}
